<template>
  <div>
    <div class="container-fluid" style="padding-bottom: 100px">
      <div class="row">
        <div class="col-md-9 mt-2" :style="userStyle" v-if="videos.length > 0">
          <video-player
            v-if="videoLoaded"
            v-bind:style="{
              overflow: 'hidden',
              borderWidth: border.borderWidth + 'px',
              borderRadius: border.radius + 'px',
              borderColor: border.borderColor,
              borderStyle: border.borderStyle
            }"
            class="vjs-matrix vjs-big-play-centered"
            :class="{ controlBg: !controlBg }"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
            @ready="playerReadied"
            @play="onPlayerPlay($event)"
            @loadeddata="onPlayerLoadeddata($event)"
          ></video-player>
          <br />
            <div>
              <div>
                <md-button class="md-raised md-primary" @click="showVideoURL = !showVideoURL"
                  >Video URL</md-button
                >
                <md-button class="md-raised md-primary" @click="showHtmlCode = !showHtmlCode"
                  >Html Code</md-button
                >
              </div>
              <md-field v-if="showHtmlCode">
                <label>Html Code</label>
                <b-form-textarea v-model="htmlCode" md-autogrow></b-form-textarea>
              </md-field>
              <md-field v-if="showVideoURL">
                <label>Video URL</label>
                <b-form-textarea v-model="videoURL" md-autogrow></b-form-textarea>
              </md-field>
            </div>
        </div>
        <div v-else class="col-md-9 pt-5">
          <h5 class="text-center">No videos Available to show, Please upload video!</h5>
        </div>
        <div class="col-md-3 sidebar">
          <div style="clear: both;"></div>
          <ul class="pt-4" v-if="videos.length > 0">
            <li 
              class="videos"
              v-for="(video, index ) in videos"
              v-bind:key="video.Id"
              v-bind:class="{ active: index == videoId }"
            >
              <div v-on:click="play(index)">
                <div class="video">
                  <div class="poster" :style="{ background: getPoster(video) }"></div>
                  <p>{{ video.name }}</p>
                  <p class="time">
                    <vue-moments-ago prefix suffix="ago" :date="video.date" lang="en" />
                  </p>
                </div>
                <div style="clear: both;"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VueMomentsAgo from "vue-moments-ago";
import Verte from "verte";

import { videojs, videoPlayer } from "vue-video-player";
import axios from "axios";


import watermark from "videojs-watermark";

import playlist from 'videojs-playlist'
import Axios from 'axios';

videojs.registerPlugin("watermark", watermark);

videojs.registerPlugin('playlist', playlist)

export default {
  components: {
    VueMomentsAgo,
    Verte,
    videoPlayer
  },
  data: () => ({
    search: null,
    searched: [],
    // videos: [],
    elementColor: "#fff",
    videoLoaded: false,
    // Poster
    showPoster: false,
    poster: "",

    // watermark
    showWatermark: false,
    watermark: require("@/assets/logo.png"),
    watermarkPosition: "bottom-left",
    watermarkUrl: undefined,

    showTitle: true,
    controlBg: true,
    // showTime: true,

    htmlCode: null,
    videoURL: null,
    videoId: null,
    showHtmlCode: false,
    showVideoURL: false,
    // border and radius
    border: {
      borderWidth: 0,
      borderColor: "#525252",
      borderStyle: "solid",
      radius: 0
    },

    videos: [],
    videoList: [],

    playerOptions: {
      aspectRatio: "16:9",
      autoplay: false,
      controls: true,
      muted: false,
      loop: false,
      language: "en",
      preload: "auto",
      playbackRates: [0.7, 1.0, 1.5, 2.0],
    //   sources: [
    //     {
    //       type: "video/mp4",
    //       src: ""
    //     }
    //   ],
      poster: "",

      controlBar: {
        // Hide and show time
        currentTimeDisplay: true,
        // should be default values and not saved in db
        timeDivider: false,
        durationDisplay: false,
        remainingTimeDisplay: false,

        // FUll SCRENN button
        fullscreenToggle: true,

        // Video timeline
        progressControl: true,

        // audo control
        volumePanel: true,

        playToggle: true,

        playbackRateMenuButton: true
      }
    }
  }),

  watch: {
    videos: function(val) {
      if (val.length > 0) {
        this.setActiveVideo(val[0]);
      }
    }
  },
  created() {
    this.getPlaylist(this.$route.params.id);
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    userStyle() {
      return {
        "--element-color": this.elementColor
      };
    }
  },
  mounted() {
    this.$store.dispatch("loadUserVideos");
    this.$store.dispatch("loadClientplaylists");
  },
  methods: {
      play(index){
        //   console.log(index)
        //   console.log(this.player)
          this.player.playlist.currentItem(index)
          this.videoId = index;
      },
    getPlaylist(id) {
        Axios.get(`${process.env.VUE_APP_API_URL}/api/client/playlists/${id}`)
        .then(res => {
            let vds = []
            if(res.data.videos) {
                vds = res.data.videos.sort((a) => a.order)
            }
            vds.forEach(video => {
                this.videos.push(video.video);
                this.videoList.push(  {
                    sources: [
                        {
                            src: `${process.env.VUE_APP_API_URL}/api/clientVideos/watch/${video.video._id}`,
                            type: "video/mp4"
                        }
                    ],
                    poster:  `${process.env.VUE_APP_API_URL}/${video.video.poster}`,
                    title : video.video.name,
                },) 
            });
        })
        .catch(error => {
            console.log(error);
            this.$router.push({ name: "404" });
        });
    },
    setActiveVideo(video) {
    //   this.playerOptions.sources[0].src = `${process.env.VUE_APP_API_URL}/api/clientVideos/watch/${
    //     video._id
    //   }`;
    
      this.htmlCode = `<iframe frameborder="0" allowfullscreen width="800" height="500" src="${
        process.env.VUE_APP_API_URL
      }/preview/reiframe/${video._id}"></iframe>`;
      this.videoURL = `${process.env.VUE_APP_API_URL}/preview/reiframe/${video._id}`;
      this.videoId = 0;
      
      this.playerOptions.autoplay = video.autoplay;
      this.playerOptions.controls = video.controls;
      this.playerOptions.muted = video.muted;
      this.playerOptions.loop = video.loop;
      // Poster
      this.showPoster = video.showPoster;
      if (video.showPoster) {
        this.playerOptions.poster = `${process.env.VUE_APP_API_URL}/${video.poster}`;
      }
      this.poster = `${process.env.VUE_APP_API_URL}/${video.poster}`;

      this.border.borderWidth = video.borderWidth;
      this.border.borderColor = video.borderColor;
      this.border.borderStyle = video.borderStyle;
      this.border.radius = video.radius;

      this.playerOptions.controlBar.currentTimeDisplay = video.currentTimeDisplay;
      this.playerOptions.controlBar.fullscreenToggle = video.fullscreenToggle;
      this.playerOptions.controlBar.progressControl = video.progressControl;
      this.playerOptions.controlBar.volumePanel = video.volumePanel;
      this.playerOptions.controlBar.playToggle = video.playToggle;
      this.playerOptions.controlBar.playbackRateMenuButton = video.playbackRateMenuButton;

      (this.showTitle = video.showTitle),
        (this.controlBg = video.controlBg),
        (this.videoLoaded = true);

      // watermark
      this.showWatermark = video.showWatermark;
      this.watermark = `${process.env.VUE_APP_API_URL}/${video.watermark}`;
      this.watermarkPosition = video.watermarkPosition;
      this.watermarkUrl = video.watermarkUrl;
      this.elementColor = video.elementColor;
    },
 
    preview() {
      this.$router.push({ name: "preview", params: { id: this.videoId } });
    },
    
    playerReadied(player) {
        this.player.playlist(this.videoList);
        /* ADD PREVIOUS */
        var Button = videojs.getComponent("Button");
        // Extend default
        var PrevButton = videojs.extend(Button, {
        //constructor: function(player, options) {
        constructor: function() {
            Button.apply(this, arguments);
            /* NEW VIDEOJS ICON PREV NEXT */
            this.addClass("vjs-icon-previous-item");
            this.controlText("Previous");
            },   
                handleClick: function() {
                    player.playlist.previous();
                }
        });

            /* ADD BUTTON */
            //var Button = videojs.getComponent('Button');

            // Extend default
            var NextButton = videojs.extend(Button, {
            //constructor: function(player, options) {
            constructor: function() {
                Button.apply(this, arguments);
         
                /* NEW VIDEOJS ICON PREV NEXT */
                this.addClass("vjs-icon-next-item");
                this.controlText("Next");
            },

            handleClick: function() {
                player.playlist.next();
            }
        });

        videojs.registerComponent("NextButton", NextButton);
        videojs.registerComponent("PrevButton", PrevButton);
        player.getChild("controlBar").addChild("PrevButton", {}, 0);
        player.getChild("controlBar").addChild("NextButton", {}, 2);
       
    },
    onPlayerPlay(player){
        // var playIndex = player.playlist.currentIndex()
        // player.playlist.currentItem(playIndex); // play third
        // player.play();
        // this.player.playlist(this.videoList);
        this.videoId = player.playlist.currentIndex()
    },
    onPlayerLoadeddata(player) {
        let video = this.videos[player.playlist.currentIndex()]
        // this.setActiveVideo(this.videos[player.playlist.currentIndex()])
         this.htmlCode = `<iframe frameborder="0" allowfullscreen width="800" height="500" src="${
                process.env.VUE_APP_API_URL
            }/preview/reiframe/${video._id}"></iframe>`;
            this.videoURL = `${process.env.VUE_APP_API_URL}/preview/reiframe/${video._id}`;            
            // this.playerOptions.autoplay = video.autoplay;
            // this.playerOptions.controls = video.controls;
            // this.playerOptions.muted = video.muted;
            // this.playerOptions.loop = video.loop;
            // Poster
            this.showPoster = video.showPoster;
            if (video.showPoster) {
                // this.playerOptions.poster = `${process.env.VUE_APP_API_URL}/${video.poster}`;
            }
            this.poster = `${process.env.VUE_APP_API_URL}/${video.poster}`;

            this.border.borderWidth = video.borderWidth;
            this.border.borderColor = video.borderColor;
            this.border.borderStyle = video.borderStyle;
            this.border.radius = video.radius;

            // this.playerOptions.controlBar.currentTimeDisplay = video.currentTimeDisplay;
            // this.playerOptions.controlBar.fullscreenToggle = video.fullscreenToggle;
            // this.playerOptions.controlBar.progressControl = video.progressControl;
            // this.playerOptions.controlBar.volumePanel = video.volumePanel;
            // this.playerOptions.controlBar.playToggle = video.playToggle;
            // this.playerOptions.controlBar.playbackRateMenuButton = video.playbackRateMenuButton;

            (this.showTitle = video.showTitle),
                (this.controlBg = video.controlBg),
                (this.videoLoaded = true);

            // watermark
            this.showWatermark = video.showWatermark;
            this.watermark = `${process.env.VUE_APP_API_URL}/${video.watermark}`;
            this.watermarkPosition = video.watermarkPosition;
            this.watermarkUrl = video.watermarkUrl;
            this.elementColor = video.elementColor;
    },

    getPoster(video) {
      if (video.poster == undefined) {
        return;
      } else {
        return `url('${process.env.VUE_APP_API_URL}/${video.poster}')`;
      }
    },
  }
};
</script>

<style lang="scss">
.videos {
  position: relative;
  .delete-icon {
    display: none;
    position: absolute;
  }
}
.videos:hover {
  position: relative;
  .delete-icon {
    display: block;
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
}


.vjs-matrix .vjs-button > .vjs-icon-placeholder:before,
.vjs-matrix .vjs-playback-rate,
.vjs-matrix.video-js,   
.vjs-button {
  color: var(--element-color) !important;
}
/* Change the border of the big play button. */
.vjs-matrix .vjs-big-play-button {
  border-color: var(--element-color);
  color: var(--element-color);
}

/* Change the color of various "bars". */
.vjs-matrix .vjs-volume-level,
.vjs-matrix .vjs-play-progress,
.vjs-matrix .vjs-slider-bar  {
  background: var(--element-color);
}
</style>
